export default "__VITE_PUBLIC_ASSET__1b1db91e__"